import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItem = ({ id, value, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    marginBottom: "10px",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "10px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    position: "relative", // Zorgt ervoor dat de knop zich binnen deze container positioneert
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      {/* Verwijderknop rechtsboven */}
      <button
        type="button"
        className="btn btn-danger"
        onClick={(e) => {
          e.stopPropagation(); // Voorkomt dat dnd-kit drag event triggert
          onRemove(id);
        }}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          padding: "3px 8px",
          fontSize: "12px",
          lineHeight: "1",
          zIndex: 10,
        }}
      >
        ×
      </button>

      {/* Dragbaar gedeelte */}
      <div {...listeners} style={{ cursor: "grab" }}>
        <div className="media">
          <div className="media-left">
            <img
              src={value.thumbnail.small}
              alt={value.titel}
              className="media-object"
              style={{
                width: 120,
                height: 90,
                borderRadius: 4,
                boxShadow: "0 1px 3px rgba(0,0,0,.15)",
                objectFit: "cover",
              }}
            />
          </div>
          <div className="media-body" style={{ paddingLeft: "15px" }}>
            <h5 style={{ marginTop: 0, marginBottom: "5px", fontSize: "14px" }}>{value.titel}</h5>
            <p style={{ margin: 0, fontSize: "12px", color: "#666" }}>
              {value.image && (
                <small>Bestand: {value.image.split('/').pop()}</small>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortableItem;